import { UPDATE_AUTH } from 'apps/auth/actions/authAction';
import update from 'apps/auth/helpers/Immutability';

const auth = (state = {}, action) => {
    let mergeState;
    const data = action.data;
    switch (action.type) {
        case UPDATE_AUTH:
            mergeState = update(state, {
                $auto: { $set: data },
            });
            break;
        default:
            return state;
    }
    return mergeState;
};
export default auth;
